export default __webpack_public_path__ + "static/media/status_error.e2ae889e.svg";